import * as angular from 'angular';

import { IUploadedFileData, IUploadedFilesData } from '../../models';
import { INgFileUploadService, UploadPromise } from '../../services';

export interface IUploadService {
    uploadFile<T>(url: string, file: File, progressCalback?): UploadPromise<T>;
    uploadFiles<T>(url: string, files: File[]): UploadPromise<T>;
    uploadData<T>(uploadedData: IUploadedFileData): UploadPromise<T>;
    uploadFileWithEvent<T>(url: string, file: File): UploadPromise<T>;
    download(data: any, fileName: string, mediaType: string): void;
}

export class UploadService implements IUploadService {
    static serviceId = 'uploadService';

    static $inject = ['Upload'];

    constructor(private _upload: INgFileUploadService) {
    }

    uploadFile<T>(url: string, file: File, progressCalback?): UploadPromise<T> {
        const uploadedData = { url: url, file: file } as IUploadedFileData;
        return this._upload
            .upload(uploadedData)
            .progress(e => progressCalback(e))
            .then(data => data.data);
    }

    uploadFiles<T>(url: string, files: File[]): UploadPromise<T> {
        const uploadedData = { url: url, file: files } as IUploadedFilesData;
        return this._upload
            .upload(uploadedData)
            .then(data => data.data);
    }

    uploadFileWithEvent<T>(url: string, file: File): UploadPromise<T> {
        const uploadedData = { url: url, file: file } as IUploadedFileData;
        return this._upload
            .upload(uploadedData)
            .then(data => {
                return data as UploadPromise<T>;
            });
    }


    uploadData<T>(uploadedData: IUploadedFileData): UploadPromise<T> {
        return this._upload
            .upload(uploadedData)
            .then(data => data.data);
    }

    download(data: any, fileName: string, mediaType: string): void {
        // IE fallback
        const dataBlob = data
            ? new Blob([`\uFEFF${decodeURIComponent(encodeURI(data))}`], {
                type: `${mediaType};charset=utf-8;`
            })
            : new Blob();
        const blob = dataBlob;
        const nav = (window.navigator as any);
        if (nav.msSaveOrOpenBlob) {
            nav.msSaveBlob(blob, fileName);
        } else {
            const anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);
            const url = URL.createObjectURL(blob);
            (anchor.attr({
                href: url,
                target: '_blank',
                download: fileName
            })[0] as HTMLElement).click();
            URL.revokeObjectURL(url);
            anchor.remove();
        }
    }
}